<template>
  <div class="section__container">
    <ol class="timeline">
      <li v-for="(item, index) in property.attributes.property_buying_processes.data" :key="index"  class="timeline-item">
		<span class="timeline-item-icon | faded-icon">
          <i class="avatar | small">
			  <img :src="item.attributes.Type === 'Active' ? IcnActive : item.attributes.Type === 'Regular' ? IcnOld : IcnTBD" />
          </i>
        </span>
        <div class="timeline-item-wrapper">
          <div class="timeline-item-description">
            <span class="timeline-date"><time datetime="22-12-2022">{{ returnDate(item.attributes.Date, item.attributes.Type) }}</time></span>
          </div>
          <div class="commen2t">
            <p class="timeline-title">{{ item.attributes.Title }} </p>
            <p class="timeline-description">{{ item.attributes.Detail }}</p>
            
          </div>
        </div>
      </li>
      <!--li class="timeline-item">
        <span class="timeline-item-icon | faded-icon">
          <i class="avatar | small">
              <img :src="IcnOld" />
          </i>
        </span>
        <div class="timeline-item-wrapper">
          <div class="timeline-item-description">
            <span class="timeline-date"><time datetime="22-12-2022">December 22, 2022</time></span>
          </div>
          <div class="commen2t">
            <p class="timeline-title">Token Offering</p>
            <p class="timeline-description">tokens are available to purchase. Once purchased, tokens will automatically be sent to the Algorand wallet address you've provided.
            You begin receiving daily rental income on the same day you invest.</p>
            
          </div>
        </div>
      </li>
      <li class="timeline-item | extra-space">
        <span class="timeline-item-icon | faded-icon">
          <i class="avatar | small">
              <img :src="IcnTBD" />
          </i>
        </span>
        <div class="timeline-item-wrapper">
          <div class="timeline-item-description">
            <span class="timeline-date">TBD</span>
          </div>
          <div class="commen2t">
            <p class="timeline-title">Token Offering Complete</p>
            <p class="timeline-description">
              The value of your tokens over time is based on the fair-market-value (FMV) of the property itself.

The fair-market-value (FMV) of the property over time is determined by taking the rate-of-change of the HouseCanary Automated Valuation Model (AVM) on a monthly basis, then applying that same rate-of-change to your token’s Principle Value on a monthly basis.
All properties will have their FMV updated around one month after the property sale is recorded on HouseCanary. After that, the FMV will be updated monthly moving forward.

The HouseCanary AVM is updated once per month between the 28th-7th, so our properties' FMV update will occur within that time frame as well. Every time the FMV updates for a property, there will be a report from HouseCanary attached which walks through exactly how their AVM was calculated.

This process is done to estimate an increase or a decrease in your property's value over time.
            </p>
            
          </div>
        </div>
      </li-->
    </ol>
  </div>
</template>
<script>
import IcnActive from '@/assets/property/buying/active.png'
import IcnOld from '@/assets/property/buying/old.png'
import IcnTBD from '@/assets/property/buying/tbd.png'
import moment from 'moment'
export default {
  name: 'FinancialsTab',
  props: {
    property: {
      type: Object,
      required: true
    }
  },
  created () {
    console.log('ESto paso en la property Details', this.property)
  },
  data () {
    return {
      IcnActive:IcnActive,
      IcnOld:IcnOld,
      IcnTBD:IcnTBD
    }
  },
  methods: {
	returnDate (value, type) {
		let response = 'TBD'
		if (type !== 'TBD') {
			response = moment(value).format('LL')
		} 

		return response
		
	}
  }
}
</script>
<style lang="scss">
.section__container {
  display: flex;
  flex-direction: column;
  gap: 44px;
}


:root {
	--c-grey-100: #f4f6f8;
	--c-grey-200: #e3e3e3;
	--c-grey-300: #b2b2b2;
	--c-grey-400: #7b7b7b;
	--c-grey-500: #3d3d3d;

	--c-blue-500: #688afd;
}


.timeline-description {
  //styleName: Roboto Regular/RR16-22;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: #000000;
}

.timeline-date {
  //styleName: Secondary/RR14;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #6C6970;
}

.timeline-title {
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  color: #351467;
}

img {
	display: block;
	max-width: 100%;
}
/* End basic CSS override */

.timeline {
	width: 85%;
	max-width: 700px;
	margin-left: auto;
	margin-right: auto;
	display: flex;
	flex-direction: column;
	padding: 32px 0 32px 32px;
	border-left: 2px solid var(--c-grey-200);
	font-size: 1.125rem;
}

.timeline-item {
	display: flex;
	gap: 24px;
	& + * {
		margin-top: 24px;
	}
	& + .extra-space {
		margin-top: 48px;
	}
}

.new-comment {
	width: 100%;
	input {
		border: 1px solid var(--c-grey-200);
		border-radius: 6px;
		height: 48px;
		padding: 0 16px;
		width: 100%;
		&::placeholder {
			color: var(--c-grey-300);
		}

		&:focus {
			border-color: var(--c-grey-300);
			outline: 0; // Don't actually do this
			box-shadow: 0 0 0 4px var(--c-grey-100);
		}
	}
}

.timeline-item-icon {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	margin-left: -52px;
	flex-shrink: 0;
	overflow: hidden;
	box-shadow: 0 0 0 6px #fff;
	svg {
		width: 20px;
		height: 20px;
	}

	&.faded-icon {
		background-color: var(--c-grey-100);
		color: var(--c-grey-400);
	}

	&.filled-icon {
		background-color: var(--c-blue-500);
		color: #fff;
	}
}

.timeline-item-description {
	display: flex;
	padding-top: 6px;
	gap: 8px;
	color: var(--c-grey-400);

	img {
		flex-shrink: 0;
	}
	a {
		color: var(--c-grey-500);
		font-weight: 500;
		text-decoration: none;
		&:hover,
		&:focus {
			outline: 0; // Don't actually do this
			color: var(--c-blue-500);
		}
	}
}

.avatar {
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	overflow: hidden;
	aspect-ratio: 1 / 1;
	flex-shrink: 0;
	width: 40px;
	height: 40px;
	&.small {
		width: 28px;
		height: 28px;
	}

	img {
		object-fit: cover;
	}
}

.comment {
	margin-top: 12px;
	color: var(--c-grey-500);
	border: 1px solid var(--c-grey-200);
	box-shadow: 0 4px 4px 0 var(--c-grey-100);
	border-radius: 6px;
	padding: 16px;
	font-size: 1rem;
}

.button {
	border: 0;
	padding: 0;
	display: inline-flex;
	vertical-align: middle;
	margin-right: 4px;
	margin-top: 12px;
	align-items: center;
	justify-content: center;
	font-size: 1rem;
	height: 32px;
	padding: 0 8px;
	background-color: var(--c-grey-100);
	flex-shrink: 0;
	cursor: pointer;
	border-radius: 99em;

	&:hover {
		background-color: var(--c-grey-200);
	}

	&.square {
		border-radius: 50%;
		color: var(--c-grey-400);
		width: 32px;
		height: 32px;
		padding: 0;
		svg {
			width: 24px;
			height: 24px;
		}

		&:hover {
			background-color: var(--c-grey-200);
			color: var(--c-grey-500);
		}
	}
}

.show-replies {
	color: var(--c-grey-300);
	background-color: transparent;
	border: 0;
	padding: 0;
	margin-top: 16px;
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 1rem;
	cursor: pointer;
	svg {
		flex-shrink: 0;
		width: 24px;
		height: 24px;
	}

	&:hover,
	&:focus {
		color: var(--c-grey-500);
	}
}

.avatar-list {
	display: flex;
	align-items: center;
	& > * {
		position: relative;
		box-shadow: 0 0 0 2px #fff;
		margin-right: -8px;
	}
}

</style>